/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Staff_RevenueInputs */

const vi_report_staff_revenue = /** @type {(inputs: Report_Staff_RevenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doanh thu`)
};

/**

* @param {Report_Staff_RevenueInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_staff_revenue = /** @type {((inputs?: Report_Staff_RevenueInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Staff_RevenueInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_staff_revenue(inputs)
});